import _taggedTemplateLiteral from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2;
var _ = function _(t) {
    return t;
  },
  _t,
  _t2;
import mediaQueries from "../../../../util/mediaqueries";
import { spacing } from "../../../../util/spacing";
import { MOBILE_HEADER_HEIGHT } from "../../../../constants/design";
import styled, { css } from 'styled-components';
export var MobileMenuTriggerContainer = styled.div.withConfig({
  componentId: "sc-1op33t7-0"
})(["order:1;position:relative;", ""], mediaQueries.md(_t || (_t = _(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: none;\n  "]))))));
export var TriggerButton = styled.button.withConfig({
  componentId: "sc-1op33t7-1"
})(["border:none;background:none;cursor:pointer;padding:0;font-size:0;position:relative;color:inherit;width:", ";height:", "px;margin-right:-", ";", ""], spacing(7), MOBILE_HEADER_HEIGHT, spacing(2), mediaQueries.sm(_t2 || (_t2 = _(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    margin-right: -", ";\n    width: ", ";\n  "])), 0, 0)), spacing(3), spacing(9)));
export var NoJsMenuTrigger = styled.input.attrs({
  type: 'checkbox'
}).withConfig({
  componentId: "sc-1op33t7-2"
})(["display:none;position:absolute;top:0;left:0;right:-", ";bottom:0;margin:0;background:none;appearance:none;border:none;cursor:pointer;"], spacing(3));
export var triggerSvgVisibleStyles = css(["visibility:visible;opacity:1;"]);
export var TriggerSvg = styled.svg.attrs({
  xmlns: 'http://www.w3.org/2000/svg',
  width: '24',
  height: '24',
  fill: 'none',
  viewBox: '0 0 24 24'
}).withConfig({
  componentId: "sc-1op33t7-3"
})(["position:absolute;top:calc(50% - 12px);left:calc(50% - 12px);bottom:0;right:0;visibility:hidden;opacity:0;will-change:opacity,visibility;transition:opacity 200ms ease-in-out,visibility 200ms ease-in-out;", ""], function (_ref) {
  var isVisible = _ref.isVisible;
  return isVisible && triggerSvgVisibleStyles;
});